import {
  Text,
  GreyGrey70,
  IconCircleX,
  IconReceiptBill,
  Primary13Regular,
  Primary13SemiBold
} from '@sequencehq/core-components'

import { toMoney } from '@sequencehq/utils'

import { InvoicePreviewCard, NodeTimeline } from 'Automations/components'
import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { getHumanReadableInvoiceNumber } from 'Invoices/utils'
import { TaskInput } from './types'
import { formatAccountingDate } from './formatAccountingDate'
import { useInvoiceData } from '../../hooks/useInvoiceData'

export const InvoiceAutoIssueAccountingLockedPreview = (props: {
  taskId: string
}) => {
  const { manualTask } = useManualTask({ taskId: props.taskId })
  const input = manualTask?.input as TaskInput | undefined
  const { invoice, customer, invoiceDetails } = useInvoiceData(input?.invoiceId)

  const hasInvoiceData = invoice && customer && invoiceDetails

  return (
    <>
      <NodeTimeline.Item icon={<IconReceiptBill />} showStem>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label="Invoice created"
            timestamp={invoice?.createdAt}
          />
        </NodeTimeline.Title>

        {hasInvoiceData && (
          <InvoicePreviewCard
            invoice={invoice}
            customer={customer}
            invoiceDetails={invoiceDetails}
            startCollapsed
          />
        )}
      </NodeTimeline.Item>

      <NodeTimeline.Item icon={<IconCircleX />} showStem={false} highlightIcon>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label={
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                Auto-issue blocked by accounting lock
              </Text>
            }
            timestamp={manualTask?.createdAt}
          />
        </NodeTimeline.Title>

        {hasInvoiceData && input && (
          <>
            <Text {...Primary13Regular} color={GreyGrey70} marginBottom="16px">
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                {getHumanReadableInvoiceNumber({
                  invoiceNumber: invoice.invoiceNumber,
                  invoiceStatus: invoice.status
                })}
              </Text>{' '}
              for{' '}
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                {customer.legalName}
              </Text>{' '}
              (
              {toMoney({
                value: invoice.grossTotal,
                currency: invoice.currency
              })}
              ) remains a draft because its accounting date of{' '}
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                {formatAccountingDate(input.accountingDate)}
              </Text>{' '}
              is before the accounting lock date of{' '}
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                {formatAccountingDate(input.accountingLockDate)}
              </Text>
              .
            </Text>

            <InvoicePreviewCard
              invoice={invoice}
              customer={customer}
              invoiceDetails={invoiceDetails}
            />
          </>
        )}
      </NodeTimeline.Item>
    </>
  )
}
